/**
 * Created with IntelliJ IDEA.
 * User: saltrichter
 *
 * Controller is responsible to display the extended container for notificationtab
 */

define(function (require) {
    "use strict";
    var LE = require("app");
    var Loader = require("ui/loader/Loader");
    var NotificationExtendedContainerLayout = require("connection-views/layouts/notificationTab/NotificationExtendedContainerLayout");
    var NotificationTabController = {};
    var CP_CONST = require("connection-const");

    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        NotificationTabController = Marionette.Controller.extend({

            initialize: function (options) {
                this.connectionPanelContextModel = options.connectionPanelContextModel;
                this.channel = LEConnection.media.channel(LE.mediaCodes.connection.channels.CONTENT_CONTAINER);
                this.notificationTabChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.NOTIFICATION_TAB);
                this._createNotificationLayout();
                this._setEventListeners();
            },
            _setEventListeners: function () {
                this.listenTo(this.connectionPanelContextModel, "change:topElement",this._onTopElementChange);
                this.listenTo(this.channel.vent,"NotificationExtendedContainerController::container:close", this._setNotificationClosed);
                this.listenTo(this.notificationContainerLayout, "NotificationExtendedContainerController::container:close", this._setNotificationClosed);
                this.listenTo(this.channel.vent, "NotificationExtendedContainerController::container:displayNotificationView", this._displayExtendedView);
                this.listenTo(LEConnection.vent, 'notification:notification:error', this._onError);
                this.listenTo(LEConnection.vent, 'layout:domain:ready', this._setNotificationLayout);
            },

            _setNotificationClosed: function () {
                //closes the extended panel
                this.connectionPanelContextModel.setSelectedNotification(null);
                this.connectionPanelContextModel.setNotificationViewIsOpen(false);
                this.notificationContainerLayout.close();
            },

            _onError: function () {
                this._cleanup();
            },
            _setNotificationLayout: function () {
                LEConnection.vent.trigger("ConnectionPanelLayoutController:showRegion:Notification", {
                    view: this.notificationContainerLayout
                });
            },

            _createNotificationLayout: function () {
                this.notificationContainerLayout = new NotificationExtendedContainerLayout({
                    model: this.connectionPanelContextModel
                });
            },

            _onTopElementChange: function () {
                this.notificationContainerLayout.setOnTop(this.connectionPanelContextModel.getTopElement()===CP_CONST.PAGE.NOTIFICATION);
            },

            _displayView: function (view) {
                if (view) {
                    //this.articleContainerLayout.fadeInFadeOut();
                    this.notificationContainerLayout.show();
                    this.notificationContainerLayout.pageBodyRegion.show(view);
                } else {
                    this._onError();
                }
            },

            _displayExtendedView: function (_options) {
                var options = _options ||{};
                this._displayView(options.view);
                this.connectionPanelContextModel.setNotificationViewIsOpen(true);
                _.defer(_.bind(function(){
                    this.notificationContainerLayout.openExtendedView();
                },this));
            },

            _cleanup: function () {
                this._hideNoData();
                this._closeLoader();
            },

            _hideNoData: function () {
                this.notificationContainerLayout.toggleNoData(true);
            },

            //------------------------------------------------------------
            // Loader Logic
            //------------------------------------------------------------

            _closeLoader: function () {
                if (this.loader) {
                    this.loader.close();
                }
            },
            _showLoader: function () {
                this.loader = new Loader({
                    permutation: Loader.PERMUTATION.G,
                    el: this.notificationContainerLayout.ui.pageBody
                });
                this.loader.render();
            }
        });

    });
    return NotificationTabController;
});


